import { Form } from 'react-final-form';
import { useTranslation } from '../../../utils/useTranslation';
import { Button } from '../../input/Button';
import { Flex } from '../../layout/Flex';
import { Spin } from '../../layout/Spin/Spin';
import { Typography } from '../../typography/Typography';
import { ErrorMessage } from '../PartnerRegistrationForm/components/ErrorMessage';
import { fieldsMap } from '../PartnerRegistrationForm/constants';
import { PartnerRegistrationFromFields } from '../PartnerRegistrationForm/parts/PartnerRegistrationFromFields';
import { ActionButtonWrapper } from '../PartnerRegistrationForm/styles';
import { PartnerSignerDataFormProps } from './types';

export const PartnerSignerDataPage = ({
    onSubmit,
    isLoading,
    errorMessage,
    fieldErrors,
}: PartnerSignerDataFormProps) => {
    const t = useTranslation();

    return (
        <>
            <Typography variant="title3" weight="medium">
                {t('Подписант')}
            </Typography>
            <Typography mt={0.5} variant="body">
                {t('Будет подписывать документы от имени организации')}
            </Typography>

            <Form
                onSubmit={onSubmit}
                render={({ handleSubmit, invalid, pristine }) => (
                    <Flex as="form" width="100%" height="100%" onSubmit={handleSubmit}>
                        <PartnerRegistrationFromFields
                            fields={fieldsMap.signerData}
                            errors={fieldErrors}
                        />
                        <ActionButtonWrapper>
                            <Button
                                size="l"
                                width="100%"
                                color="primary"
                                type="submit"
                                onClick={handleSubmit}
                                disabled={invalid || pristine}
                            >
                                {isLoading ? (
                                    <Spin color="var(--color-invert)" size={20} />
                                ) : (
                                    t('Далее')
                                )}
                            </Button>
                            <ErrorMessage message={errorMessage} />
                        </ActionButtonWrapper>
                    </Flex>
                )}
            />
        </>
    );
};
